<script lang="ts">
    export let type: "text" | "number" = "text";
    export let value: string | number;
    export let required = true;
    export let helper = "";
    export let min = undefined;
    export let max = undefined;
    export let minlength = undefined;
    export let maxlength = undefined;

    export let focus = false;

    function init(el) {
        if (focus) el.focus();
    }
</script>

<div class="mb-3">
    <div class="input-group">
        <span class="input-group-text"><slot /></span>
        {#if type == "text"}
            <input
                type="text"
                class="form-control"
                bind:value
                {required}
                {minlength}
                {maxlength}
                use:init
            />
        {:else}
            <input
                type="number"
                class="form-control"
                bind:value
                {required}
                {min}
                {max}
                {minlength}
                {maxlength}
                use:init
            />
        {/if}
    </div>
    <div class="form-text">{helper}</div>
</div>
